import { render } from "./StatisticsResultsKatax.vue?vue&type=template&id=12d0d85b"
import script from "./StatisticsResultsKatax.vue?vue&type=script&lang=js"
export * from "./StatisticsResultsKatax.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Statistics/StatisticsResultsKatax.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12d0d85b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12d0d85b', __exports__)) {
    api.reload('12d0d85b', __exports__)
  }
  
  module.hot.accept("./StatisticsResultsKatax.vue?vue&type=template&id=12d0d85b", () => {
    api.rerender('12d0d85b', render)
  })

}


export default __exports__